import { createSlice } from '@reduxjs/toolkit';
const initialState = {
    isRequesting: false,
    error: null,
    data: [],
    total: 0,
    searchCriteria: {},
};
const slice = createSlice({
    name: 'reportTransportOrderElec',
    initialState: initialState,
    reducers: {
        get_list: (state, action) => {
            return {
                ...state,
                isRequesting: true,
                error: null,
                searchCriteria: { ...action.payload },
            };
        },
        get_list_succeed: (state, action) => {
            return {
                ...state,
                isRequesting: false,
                error: null,
                data: action?.payload?.data || [],
                total: action?.payload?.total || 0,
            };
        },
        get_list_failed: (state, action) => {
            return {
                ...state,
                isRequesting: false,
                error: action.payload.error,
            };
        },

        request_export_success: (state) => {
            const { export: exportData, ...restSearchCriteria } = state.searchCriteria;
            return {
                ...state,
                isRequesting: false,
                searchCriteria: {
                    ...restSearchCriteria,
                },
            };
        },

        reset_state: () => {
            return {
                ...initialState,
            };
        },
    },
});

export const { reducer, actions } = slice;

export default reducer;
